module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av658-87290cadb1259dc55cff0c7049db8361.jpg";